import { usePermissions } from '../../context/PermissionsContext';

const ProtectedComponent = ({ permissions = [], matchAll = false, children }) => {
    const authPermissions = usePermissions();

    if (authPermissions) {
        const hasPermissions = matchAll
            ? permissions.every(permission => authPermissions.includes(permission)) // "All" match
            : permissions.some(permission => authPermissions.includes(permission)); // "Any" match

        if (hasPermissions) {
            return children;
        }
    }

    return null;
};

export default ProtectedComponent;
